export class ConstanstIds {
    // si se agrega aca, agregar tambien en getDescriptions.ts
    public static get generoFemenino(): number { return 2; }
    public static get generoMasculino(): number { return 1; }
    public static get generoOtro(): number { return 3; }
}